const trackEvent = (name, attributes = {}, { providers = [] } = {}) => {
  if (typeof ga !== 'undefined' && providers.includes(ga)) {
    // no mapping between providers; need explicit params
    const { eventAction, eventCategory, eventLabel, eventValue } = attributes;
    ga('send', 'event', {
      eventAction,
      eventCategory,
      eventLabel,
      eventValue,
    });
  }
  if (
    typeof mParticle !== 'undefined' &&
    mParticle.EventType &&
    providers.includes(mParticle)
  ) {
    mParticle.logEvent(name, mParticle.EventType.Navigation, attributes);
  }
  // facebook tracking
  if (typeof fbq !== 'undefined' && providers.includes(fbq)) {
    fbq('track', name);
  }
  // reddit tracking
  if (typeof rdt !== 'undefined' && providers.includes(rdt)) {
    rdt('track', name);
  }
};

export default trackEvent;
